<template>
  <div class="scrollable">
    <v-container class="pa-md-6 pa-3">
      <v-row>
        <v-col>
          <v-card class="mx-auto">
            <div class="pa-4 text-center" style="line-height: 1">
              <iframe ref="iframe" :class="{ dark: darkMode }" src="about:blank" :height="iframeHeight" />
            </div>
            <v-card-subtitle v-if="description.length > 0" class="pt-0 text-center">
              {{ description }}
            </v-card-subtitle>
            <v-card-text v-if="tags.length > 0" class="text-center">
              <span v-for="(tagId, i) in tags" :key="i">
                <v-chip v-if="tagsById[tagId]" class="mr-1" small>{{ tagsById[tagId].name }}</v-chip>
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import index from '../index';
import common from '@/mixins/common';
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'HTMLViewer',
  emits: [],
  mixins: [common],
  components: {},
  props: {
    container: {
      type: Object,
      default: () => {},
    },
    media: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      iframeHeight: '50px',
      htmlData: '',
    };
  },
  computed: {
    ...mapState('media', ['tagsById']),
    mediaProperties() {
      return this.media.properties;
    },
    mediaFileName() {
      return this.mediaProperties.filename || '';
    },
    mediaChecksum() {
      return this.mediaProperties.checksum || '';
    },
    mediaMimeType() {
      return this.mediaProperties.mimetype || '';
    },
    mediaUrl() {
      return this.moduleFileUrl(index.moduleId, this.mediaFileName, this.mediaChecksum);
    },
    properties() {
      return this.container.properties ? this.container.properties : {};
    },
    description() {
      return this.properties.description ? this.properties.description : '';
    },
    tags() {
      return this.container.tags && Array.isArray(this.container.tags) ? this.container.tags : [];
    },
  },
  methods: {
    async loadHtml(url) {
      try {
        const response = await axios.get(url);
        return response ? response.data : '';
      } catch (error) {
        console.error('MEDIA_MODUL', error);
        return '';
      }
    },
    sanitizeHtml(html) {
      return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
    },
  },
  async mounted() {
    this.htmlData = this.sanitizeHtml(await this.loadHtml(this.mediaUrl));

    this.$refs.iframe.addEventListener('load', (event) => {
      event.target.contentDocument.body.style.color = 'white';
    });
  },
  watch: {
    htmlData(to, _) {
      if (to) {
        const doc = this.$refs.iframe.contentWindow.document;
        doc.open();
        doc.write(this.htmlData);
        doc.close();
        this.iframeHeight = this.$refs.iframe.contentWindow.document.body.scrollHeight + 32 + 'px';
      }
    },
  },
};
</script>
<style scoped>
.theme--dark .article-container,
.theme--dark iframe {
  background: #050505 !important;
}
.theme--light .article-container {
  background: #fff;
}
.theme--dark .article {
  background: #202020;
}
.theme--light .article {
  background: #f0f0f0;
}
iframe {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
iframe.dark {
  border: 1px solid rgba(255, 255, 255, 0.15);
}
</style>
